import React from 'react'
import moment from 'moment'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { SalesType } from '@/models/sales'

type ConfirmedUsageDetailProps = {
  index: number
  usageDetail: SalesType
  advanceCompany?: any
  canPostClosingEdit?: boolean
  onStartPostClosingEdit?: () => void
}

export const ConfirmedUsageDetail: React.FC<ConfirmedUsageDetailProps> = ({
  index,
  usageDetail,
  advanceCompany,
  canPostClosingEdit = false,
  onStartPostClosingEdit,
}) => {
  const { t } = useTranslation()

  return (
    <tr key={index} css={listItemReadWrapperStyle}>
      <td>{usageDetail.salesDate && moment(usageDetail.salesDate).format(t('MM-DD'))}</td>
      <td>
        {usageDetail.salesSubSubjectName
          ? `${usageDetail.salesSubjectName}/${usageDetail.salesSubSubjectName}`
          : usageDetail.salesSubjectName}
      </td>
      <td>{usageDetail?.roomNumber ? `${usageDetail.roomNumber}(${usageDetail.guestRoomAssignShortId})` : '-'}</td>
      <td>{Number(usageDetail.salesSubjectPrice).toLocaleString()}</td>
      <td>{Number(usageDetail.quantity).toLocaleString()}</td>
      <td>{Number(usageDetail.salesPrice).toLocaleString()}</td>
      <td>
        {usageDetail.companyId
          ? advanceCompany.paymentCompanies.find(item => item?.id === usageDetail.companyId)?.name
          : usageDetail.salesPaymentName}
      </td>
      {!usageDetail.isPaid ? <td css={unpaidStyle}>{t('Unpaid')}</td> : <td>{t('Paid')}</td>}
      <td className="accountsReceivable">{usageDetail.salesAccountsReceivableName || '-'}</td>
      <td css={actionCellStyle}>
        {canPostClosingEdit && onStartPostClosingEdit && (
          <button type="button" css={memoButtonStyle} onClick={onStartPostClosingEdit} aria-label={t('Edit')}>
            <img alt="memo" src={require('@/static/images/memo.svg')} css={memoIconStyle} />
          </button>
        )}
      </td>
    </tr>
  )
}

const unpaidStyle = css({
  color: '#F2A40B !important',
})

const listItemReadWrapperStyle = css({
  ':hover': {
    boxShadow: 'none',
    cursor: 'default',
  },
  'div.accountsReceivable': {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  td: {
    backgroundColor: '#F6F6F6',
    height: 57,
  },
})

const actionCellStyle = css({
  textAlign: 'right',
  verticalAlign: 'middle',
  paddingRight: 8,
})

const memoButtonStyle = css({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 0,
  border: 'none',
  background: 'transparent',
  cursor: 'pointer',
})

const memoIconStyle = css({
  width: 16,
  height: 16,
})
